<template>
    <div style="display: flex">
        <div class="mr-5">
            <h6>Job Category</h6>
            <label v-for="(value, key) in categories.driver" style="display: block">
                <input type="checkbox" v-model="data[key]"> {{ value }}
            </label>
        </div>
        <div class="mr-5">
            <h6>Equipment Type</h6>
            <label v-for="(value, key) in categories.equipment" style="display: block">
                <input type="checkbox" v-model="data[key]"> {{ value }}
            </label>
        </div>

        <div class="mr-5">
            <h6>Driving Distance</h6>
            <label v-for="(value, key) in categories.route" style="display: block">
                <input type="checkbox" v-model="data[key]"> {{ value }}
            </label>
        </div>

        <div class="mr-5">
            <h6>Teams</h6>
            <label v-for="(value, key) in categories.teams" style="display: block">
                <input type="checkbox" v-model="data[key]"> {{ value }}
            </label>
        </div>

        <div class="mr-5">
            <h6>Specialization</h6>
            <label v-for="(value, key) in categories.category" style="display: block">
                <input type="checkbox" v-model="data[key]"> {{ value }}
            </label>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'show',
            'data',
        ],
        data() {
            return {
            };
        },
        computed: {
            categories() {
                return this.globals.categories;
            }
        }
    }
</script>